'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _contacts = require('redux/modules/contacts');

var contactsActions = _interopRequireWildcard(_contacts);

var _reactI18next = require('react-i18next');

var _components = require('components');

var _toastr = require('helpers/toastr');

var _toastr2 = _interopRequireDefault(_toastr);

var _strings = require('helpers/strings');

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _SearchBar = require('components/SearchBar/SearchBar');

var _SearchBar2 = _interopRequireDefault(_SearchBar);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var ContactsList = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    contactsCount: state.contacts.contactsListData.contactsNb,
    contactsCurrentPage: state.contacts.contactsListActionData.page,
    contactsList: state.contacts.contactsListData.contacts,
    contactsListLimit: state.contacts.contactsListLimit,
    contactsListLoading: state.contacts.contactsListLoading,
    contactsListPage: state.contacts.contactsListPage,
    contactsListPaginateBy: state.contacts.contactsListPaginateBy,
    deleteContactActionData: state.contacts.deleteContactActionData,
    deleteContactLoading: state.contacts.deleteContactLoading,
    kw: state.contacts.kw
  };
}, (0, _extends3.default)({}, contactsActions)), _dec2 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(ContactsList, _Component);

  function ContactsList() {
    var _ref;

    (0, _classCallCheck3.default)(this, ContactsList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = ContactsList.__proto__ || (0, _getPrototypeOf2.default)(ContactsList)).call.apply(_ref, [this].concat(args)));

    _this.state = { cachedCount: 0 };
    return _this;
  }

  (0, _createClass3.default)(ContactsList, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var contactsCount = this.props.contactsCount;

      if (typeof nextProps.contactsCount === 'undefined' && contactsCount) {
        this.setState({ cachedCount: contactsCount });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.filter('');
    }
  }, {
    key: 'setLimit',
    value: function setLimit(limit) {
      this.props.setContactsListLimit(Number(limit));
    }
  }, {
    key: 'deleteContact',
    value: function deleteContact(contact) {
      var _props = this.props,
          deleteContact = _props.deleteContact,
          t = _props.t,
          onDelete = _props.onDelete;

      var toastrConfirmOptions = {
        onOk: function onOk() {
          deleteContact(contact.id).promise.then(onDelete);
        },
        onCancel: function onCancel() {}
      };
      _toastr2.default.confirm(t('Are you sure you want to delete this contact?'), toastrConfirmOptions);
    }
  }, {
    key: 'loadContactsPage',
    value: function loadContactsPage(_ref2) {
      var page = _ref2.page,
          limit = _ref2.limit;
      var _props2 = this.props,
          loadContacts = _props2.loadContacts,
          kw = _props2.kw;

      loadContacts({ page: page, limit: limit, kw: kw });
    }
  }, {
    key: 'filter',
    value: function filter(kw) {
      var _props3 = this.props,
          contactsListLimit = _props3.contactsListLimit,
          contactsListPage = _props3.contactsListPage,
          loadContacts = _props3.loadContacts;

      loadContacts({ page: contactsListPage, limit: contactsListLimit, kw: kw });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props4 = this.props,
          t = _props4.t,
          contactsList = _props4.contactsList,
          deleteContactLoading = _props4.deleteContactLoading,
          deleteContactActionData = _props4.deleteContactActionData,
          contactsListLoading = _props4.contactsListLoading,
          limit = _props4.limit,
          kw = _props4.kw,
          contactsCurrentPage = _props4.contactsCurrentPage,
          contactsCount = _props4.contactsCount,
          contactsListPaginateBy = _props4.contactsListPaginateBy,
          contactsListLimit = _props4.contactsListLimit;
      var cachedCount = this.state.cachedCount;

      var count = typeof contactsCount === 'undefined' ? cachedCount : contactsCount;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_SearchBar2.default, {
          delay: 600,
          className: 'margin-vert-20',
          kw: kw,
          onChange: this.filter
        }),
        _react2.default.createElement(
          'div',
          { className: 'pos-rel' },
          _react2.default.createElement(
            _components.List,
            null,
            _react2.default.createElement(
              _components.ListItem,
              { fullWidth: true, isTitle: true },
              _react2.default.createElement(
                'div',
                null,
                t('Email')
              ),
              _react2.default.createElement(
                'div',
                null,
                t('Name')
              ),
              _react2.default.createElement('div', null)
            ),
            contactsList.map(function (contact) {
              return _react2.default.createElement(
                _components.ListItem,
                { fullWidth: true, key: contact.id },
                _react2.default.createElement(
                  'div',
                  { className: 'break-word' },
                  contact.email
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'break-word' },
                  (0, _strings.concat)(' ', contact.name, contact.surname)
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'moreCell' },
                  _react2.default.createElement('i', { className: 'more', onClick: function onClick(e) {
                      return _this2.contactPopover.toggle(e, contact);
                    } }),
                  deleteContactLoading && deleteContactActionData.contactId === contact.id && _react2.default.createElement(_components.Loader, { small: true, mask: true })
                )
              );
            })
          ),
          contactsListLoading && _react2.default.createElement(_components.Loader, { mask: true })
        ),
        _react2.default.createElement(
          'div',
          { className: 'margin-top-20' },
          _react2.default.createElement(
            'div',
            { className: 'pull-left padding-right-10 margin-bottom-10 nowrap' },
            _react2.default.createElement(
              'span',
              { className: 'margin-right-5' },
              t('View by'),
              ':'
            ),
            _react2.default.createElement(
              'select',
              { value: contactsListLimit, onChange: function onChange(e) {
                  return _this2.setLimit(e.target.value);
                } },
              contactsListPaginateBy.map(function (val) {
                return _react2.default.createElement(
                  'option',
                  { key: val, value: val },
                  val
                );
              })
            )
          ),
          _react2.default.createElement(_components.Pagination, {
            className: 'pull-right text-right',
            page: contactsCurrentPage || 1,
            count: count,
            limit: limit,
            onChange: this.loadContactsPage
          })
        ),
        _react2.default.createElement(
          _components.PopoverMenu,
          { id: 'contactPopover', ref: function ref(el) {
              return _this2.contactPopover = el;
            } },
          _react2.default.createElement(
            'li',
            { onClick: function onClick() {
                return _this2.deleteContact(_this2.contactPopover.data);
              } },
            t('Delete'),
            _react2.default.createElement('i', { className: 'icon-delete' })
          )
        )
      );
    }
  }]);
  return ContactsList;
}(_react.Component), _class3.propTypes = {
  contactsCount: _propTypes2.default.number,
  contactsCurrentPage: _propTypes2.default.number,
  contactsList: _propTypes2.default.array,
  contactsListLimit: _propTypes2.default.number,
  contactsListLoading: _propTypes2.default.bool,
  contactsListPage: _propTypes2.default.number,
  contactsListPaginateBy: _propTypes2.default.array,
  deleteContact: _propTypes2.default.func,
  deleteContactActionData: _propTypes2.default.object,
  deleteContactLoading: _propTypes2.default.bool,
  filter: _propTypes2.default.func,
  kw: _propTypes2.default.string,
  limit: _propTypes2.default.number.isRequired,
  loadContacts: _propTypes2.default.func,
  onDelete: _propTypes2.default.func,
  setContactsListLimit: _propTypes2.default.func,
  t: _propTypes2.default.func
}, _class3.defaultProps = {
  onDelete: function onDelete() {}
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'loadContactsPage', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'loadContactsPage'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'filter', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'filter'), _class2.prototype)), _class2)) || _class) || _class);
exports.default = ContactsList;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Contacts/ContactsList.js
// module id = 1974
// module chunks = 1